module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-BlackItalic.5af07079.woff";